import { render, staticRenderFns } from "./TopbarLanguage.vue?vue&type=template&id=4b64c500&scoped=true"
import script from "./TopbarLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopbarLanguage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopbarLanguage.vue?vue&type=style&index=0&id=4b64c500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64c500",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSelectOption: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/components/ui/UiSelectOption.vue').default,UiSelect: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/components/ui/UiSelect.vue').default})
